$.fn.isInViewport = function() { var elementTop=$(this).offset().top,elementBottom=elementTop + $(this).outerHeight(),viewportTop=$(window).scrollTop(),viewportBottom=viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
}

$(window).on('resize scroll',function(){
  if($(window).width() < 749){
    $('.RQ-productBestPairedMn, product-recommendations').each(function(){const viewportChecker = $(this).isInViewport() ? $('.MainCombineSwatchProductInt').hide() : $('.MainCombineSwatchProductInt').show();});
    var scrollAtc = $(window).scrollTop();
    if (scrollAtc >= 130) {
        $(".MainCombineSwatchProductInt").addClass("show_me_now");
    }else{
      $(".MainCombineSwatchProductInt").removeClass("show_me_now");
    }    
  }
});

$(document).on('click','.rvm_container',function(e){e.preventDefault();
  var videoConnect=$(this).children('.rvm_vid_make').children('.videoJSHANDLE');
  const pauseChecker = videoConnect.get(0).paused ? 
    ($(this).children('.playPauseInit').addClass('hidden'),$(this).children('.playPauseInit').children('.soundMuteSure').removeClass('hidden').siblings('.soundUnmuteSure').addClass('hidden'),videoConnect.get(0).play()) :
    ($(this).children('.playPauseInit').removeClass('hidden'),$(this).children('.playPauseInit').children('.soundMuteSure').addClass('hidden').siblings('.soundUnmuteSure').removeClass('hidden'),videoConnect.get(0).pause());
})
$(document).on('mousemove','.rvm_container',function(e){ if(!$(e.target).closest('.playPauseInit').length > 0){ $(this).children('.playPauseInit').removeClass('hidden'); } })
$(document).on('mouseenter','.rvm_container',function(e){ if(!$(e.target).closest('.playPauseInit').length > 0){ $(this).siblings('.playPauseInit').removeClass('hidden'); } })
$(document).on('mouseleave','.rvm_container',function(e){ var videoConnect=$(this).children('.rvm_vid_make').children('.videoJSHANDLE');
  const miskRise= (!$(e.target).closest('.playPauseInit').length > 0, videoConnect.get(0).paused) ? $(this).children('.playPauseInit').removeClass('hidden') : $(this).children('.playPauseInit').addClass('hidden');
})




document.addEventListener('DOMContentLoaded', function () {
    var submitButton = document.getElementById('submitButton');
    submitButton.addEventListener('click', function () {
      var inputValue = document.getElementById('PostalCode').value;
        var obj = this;
        obj.querySelector('span').classList.add('hidden');
        obj.querySelector('.loading-overlay__spinner').classList.add('loading');
        obj.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        var url = '/pages/pincod'; // Replace with your actual URL

        fetch(url)
            .then(function (response) {
                return response.text();
            })
            .then(function (data) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(data, 'text/html');
                var options = doc.querySelectorAll("#PinCodSelect option");
                var matchFound = false, secondMatch = '';

                options.forEach(function (option) {
                    var optionFirstPValue = option.getAttribute('firstP');
                    obj.querySelector('span').classList.remove('hidden');
                    obj.querySelector('.loading-overlay__spinner').classList.remove('loading');
                    obj.querySelector('.loading-overlay__spinner').classList.add('hidden');

                    if (optionFirstPValue === inputValue) {
                        secondMatch = option.getAttribute('lastP');
                        matchFound = true;
                        return;
                    }
                });
                var onDelivery = document.querySelector('.Ondelivery')
              

                if (matchFound) {
                    if (secondMatch.trim() === 'TRUE') {
                        document.querySelector('.CustomAddition').innerHTML = 'Cash on delivery Available';
                        var datOuterDiv = document.querySelector('.DatOuterDiv');
                        datOuterDiv.style.display = 'block';
                      var nodelivery = document.querySelector('.Nodelivery');
                       nodelivery.style.display = 'none';
                      obj.querySelector('span').innerHTML = 'change'
                    } else {
                        var datOuterDiv = document.querySelector('.DatOuterDiv');
                        datOuterDiv.style.display = 'block';
                        var onDelivery = document.querySelector('.Ondelivery');
                        document.querySelector('.CustomAddition').innerHTML = 'Cash on delivery not Available';
                      var nodelivery = document.querySelector('.Nodelivery');
                      nodelivery.style.display = 'none';
                     obj.querySelector('span').innerHTML = 'change'
                    }
                } else {
                  var nodelivery = document.querySelector('.Nodelivery');
                  if (inputValue.length < 6) {
                      // Display the error message
                    nodelivery.style.display = 'block';
                    nodelivery.innerHTML = 'Invalid pincode. Please try again.';
                    obj.querySelector('span').innerHTML = 'change'
                  }else{
                    nodelivery.style.display = 'block';
                    nodelivery.innerHTML = 'Sorry, we do not deliver at this location. Try another PIN code.'
                    obj.querySelector('span').innerHTML = 'change'
                  }
                  var datOuterDiv = document.querySelector('.DatOuterDiv');
                        datOuterDiv.style.display = 'none';
                }
            })
            .catch(function (error) {
                console.error(error);
            });
    });

  setTimeout(function(){
    document.querySelector('.cricketAnimateMain').classList.add('animation_stopped')
  },2500)
});

